import Container, { Column } from '@/components/container/Container';
import { CustomText, TextHeadlineLarge } from '@/components/text/Texts';
import { FAQS, QUESTIONS } from '@/constants/travel-page';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { useState } from 'react';
import { MdArrowDropDown, MdArrowDropUp } from 'react-icons/md';
import styles from './accordion.module.css';

const QuestionsSection = () => {
	const [activeIndex, setActiveIndex] = useState<number | number[]>();

	return (
		<Column gap="gap-6">
			<TextHeadlineLarge text={QUESTIONS} className="text-neutral17" />
			<Accordion
				multiple
				activeIndex={activeIndex}
				onTabChange={(e) => setActiveIndex(e.index)}
				collapseIcon={<MdArrowDropUp size={24} />}
				expandIcon={<MdArrowDropDown size={24} />}
			>
				{FAQS.map((item, index) => (
					<AccordionTab
						key={`question-${index.toString()}`}
						header={
							<Container>
								{/* //TODO: double check figma, this should be title medium */}
								<CustomText
									text={item.question}
									className="text-onSurface text-[20px] leading-[28px] tracking-[0.15px]"
								/>
							</Container>
						}
						pt={{
							root: {
								className: styles.accordionRoot,
							},
							header: {
								className: styles.header,
							},
							headerIcon: {
								className: styles.headerIcon,
							},
							headerAction: {
								className: styles.headerAction,
							},
							content: {
								className: styles.content,
							},
						}}
					>
						{/* //TODO: double check figma, this should be title small */}
						<CustomText
							text={item.answer}
							className="text-onSurface text-[16px] leading-[24px] tracking-[0.1px] font-normal"
						/>
					</AccordionTab>
				))}
			</Accordion>
		</Column>
	);
};

export default QuestionsSection;
